import React, { useEffect, useState } from 'react';
import Moment from "moment";
import 'chartjs-plugin-datalabels';
import { Card, CardBody, CardTitle, Col,  Row } from "reactstrap";

import AppRequestLogDashboardFilters from "./_filters";
import { showLoader } from "../../../components/loader/loader";
import { showToastCustom } from "../../../components/toast/customToast";
import { error } from "../../../components/i18n/i18n";
import { CardChartBar } from "../../../components/charts/ChartBar";
import { CardChartPie } from "../../../components/charts/ChartPie";
import {getFirstDayOfMonth, getLastDayOfMonth, getMinutesOfDay} from "../../../util/DateTools";
import {
    transactByHourHeader,
    transactByWeekHeaders,
} from "../../../util/CartTools";
import {appRequestLogService} from "../../../jwt/_services/monitor/AppRequestLogService";
import {CardChartLine} from "../../../components/charts/ChartLine";

export default function AppRequestLogDashboard() {
    const [loading, setLoading] = useState(false);
    const today = new Date()

    const [dataFilter, setDataFilter] = useState({
        from : Moment( getFirstDayOfMonth(today.getFullYear(), today.getMonth()) ).format('yyyy-MM-DD 00:00:00'),
        to :   Moment(  getLastDayOfMonth(today.getFullYear(), today.getMonth()) ).format('yyyy-MM-DD 23:59:59'),
    });

    const [byDOM, setByDOM] = useState(null);
    const [byDOMRawData, setByDOMRawData] = useState(null);

    const [byDOW, setByDOW] = useState(null);
    const [byDOWRawData, setByDOWRawData] = useState(null);

    const [byHour, setByHour] = useState(null);
    const [byHourRawData, setByHourRawData] = useState(null);

    const [byHourMinute, setByHourMinute] = useState(null);
    const [byHourMinuteRawData, setByHourMinuteRawData] = useState(null);

    const [byMethod, setByMethod] = useState(null);
    const [byMethodRawData, setByMethodRawData] = useState(null);

    const [byOS, setByOS] = useState(null);
    const [byOSRawData, setByOSRawData] = useState(null);

    // byDOM
    const [sessionsByDOM, setSessionsByDOM] = useState(null);
    const [sessionsByDOMRawData, setSessionsByDOMRawData] = useState(null);

    // byActivity
    const [sessionsByActivity, setSessionsByActivity] = useState(null);
    const [sessionsByActivityRawData, setSessionsByActivityData] = useState(null);

    // byActivityXC
    const [sessionsByActivityXC, setSessionsByActivityXC] = useState(null);
    const [sessionsByActivityXCRawData, setSessionsByActivityXCData] = useState(null);

    // byActivityXH
    const [sessionsByActivityXH, setSessionsByActivityXH] = useState(null);
    const [sessionsByActivityXHRawData, setSessionsByActivityXHData] = useState(null);

    // sessionsByParkDay
    const [sessionsByParkDayHeaders, setSessionsByParkDayHeaders] = useState(null);
    const [sessionsByParkDay, setSessionsByParkDay] = useState(null);
    const [sessionsByParkDayRawData, setSessionsByParkDayRawData] = useState(null);

    // devicesByParkDay
    const [devicesByParkDayHeaders, setDevicesByParkDayHeaders] = useState(null);
    const [devicesByParkDay, setDevicesByParkDay] = useState(null);
    const [devicesByParkDayRawData, setDevicesByParkDayRawData] = useState(null);

    const [executionTimeMin, setExecutionTimeMin] = useState(0);
    const [executionTimeMax, setExecutionTimeMax] = useState(0);
    const [executionTimeAvg, setExecutionTimeAvg] = useState(0);
    const [ avgRequestPerMinute, setAvgRequestPerMinute] = useState(0);


    useEffect(() => {
        refreshDashboard(dataFilter);
    }, []);

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDashboard(_dataFilter);
    }

    const refreshDashboard = ( _dataFilter ) => {
        setLoading(true);
        appRequestLogService.searchDashboard( _dataFilter)
            .then(result => {
                if (result){

                    if (result?.avgRequestPerMinute !== null)
                        setAvgRequestPerMinute(result?.avgRequestPerMinute);

                    if (result?.executionTimes?.min !== null)
                        setExecutionTimeMin(result?.executionTimes?.min);

                    if (result?.executionTimes?.max !== null)
                        setExecutionTimeMax(result?.executionTimes?.max);

                    if (result?.executionTimes?.avg !== null)
                        setExecutionTimeAvg(result?.executionTimes?.avg);

                    if (result?.stats?.byDOM !== null) {
                        const temp = mapByDom(result?.stats?.byDOM);
                        setByDOM(temp);
                    }

                    if (result?.stats?.byDOW !== null)
                        setByDOW(mapByDow(result?.stats?.byDOW));

                    if (result?.stats?.byHour !== null)
                        setByHour(mapByHour(result?.stats?.byHour));

                    if (result?.stats?.byHourMinute !== null)
                        setByHourMinute(mapByHourMinute(result?.stats?.byHourMinute));

                    if (result?.methodCount !== null)
                        setByMethod(mapByMethod(result?.methodCount));

                    if (result?.stats?.byOS !== null)
                         setByOS(mapByOs(result?.stats?.byOS ));

                    // Mapeo de sesiones
                    if (result?.sessions?.byDOM !== null)
                        setSessionsByDOM(mapSessionsByDom(result?.sessions?.byDOM ));

                    if (result?.sessions?.byActivity !== null) {
                        setSessionsByActivityXC(mapSessionsByActivityXC(result?.sessions?.byActivity));
                        setSessionsByActivityXH(mapSessionsByActivityXH(result?.sessions?.byActivity));
                    }

                    if (result?.sessions?.sessionsByParkDay !== null)
                        setSessionsByParkDay(mapSessionsByParkDay( result?.sessions?.sessionsByParkDay ));

                    if (result?.sessions?.devicesByParkDay !== null)
                        setDevicesByParkDay(mapDevicesByParkDay( result?.sessions?.devicesByParkDay ));

                } else {
                    // setAcceptReject(null);
                    // setByDOW(null);
                    // setByHour(null);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setByDOW(null);
                setByHour(null);
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const mapByDom = (_byDom) => {
        const _labels = _byDom.map(item => item.label);
        const _values = _byDom.map(item => item.cant);

        let output = {}
        _labels.forEach((item, index) => {
            output = { ...output, [item]: _values[index] }
        })
        setByDOMRawData([output])

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(13,0,132)',
                    backgroundColor: 'rgba(0,80,145,0.75)',
                    borderWidth: 1,
                }
            ],
        };
    }
    const mapByDow = (_byDow) => {
        if (!_byDow || _byDow.length === 0) {
            return null;
        }

        const _labels = [ 'L', 'M', 'Mi', 'J', 'V', 'S', 'D' ];

        // Inicializar rawData con todos los días de la semana establecidos en cero
        let rawData = { 'L': 0, 'M': 0, 'Mi': 0, 'J': 0, 'V': 0, 'S': 0, 'D': 0 };

        _labels.forEach( (value, position) => {
            try {
                const dow = _byDow.find(item => item?.label === (position + 1).toString());
                // Actualizar el valor para los días que están presentes en los datos
                if (dow !== undefined) {
                    rawData[value] = dow?.cant;
                }
            } catch (error) {
                console.log(error)
            }
        });


        setByDOWRawData([ rawData ]);

        const _values = Object.values(rawData);

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(13,0,132)',
                    backgroundColor: 'rgba(0,80,145,0.60)',
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapByHour = (_byHour) => {
        if (!_byHour || _byHour.length === 0) {
            return null;
        }

        const _labels = [
            '00','01', '02', '03', '04', '05', '06', '07', '08', '09'
            , '10','11', '12', '13', '14', '15', '16', '17', '18', '19'
            , '20','21', '22', '23'
        ];

        let rawData = {}

        _labels.forEach( (value)=> {
            const hour = _byHour.find(item => item.label === value);
            rawData = {...rawData, [value]: (hour !== undefined ? hour?.cant : 0)}
        } )

        setByHourRawData([ rawData ])

        const _values = _labels.map((h) => {
            const hod = _byHour.find(item => item.label === h);
            if(hod !== undefined && hod != null)
                return hod?.cant
        });

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(13,0,132)',
                    backgroundColor: 'rgba(0,80,145,0.75)',
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapByHourMinute = (_byHourMinute) => {
        if (!_byHourMinute || _byHourMinute.length === 0) {
            return null;
        }

        const _labels = getMinutesOfDay()


        let rawData = {}

        _labels.forEach( (value)=> {
            const hour = _byHourMinute.find(item => item.label === value);
            rawData = {...rawData, [value]: (hour !== undefined ? hour?.cant : 0)}
        } )

        setByHourMinuteRawData([ rawData ])

        const _values = _labels.map((h) => {
            const hod = _byHourMinute.find(item => item.label === h);
            if(hod !== undefined && hod != null)
                return hod?.cant
        });

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(13,0,132)',
                    backgroundColor: 'rgba(0,80,145,0.75)',
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapByMethod = (_byMethod) => {
        if (!_byMethod || Object.keys(_byMethod).length === 0) {
            return null;
        }

        const _labels = Object.keys(_byMethod);
        const _values = Object.values(_byMethod);

        let output = {}
        _labels.forEach( item => {
            output = { ...output, [item]: _byMethod[item] }
        })
        setByMethodRawData([output])

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: [
                        'rgb(97,173,225)',
                        'rgba(54, 162, 235, 1)',
                        'rgb(18,137,218)',
                    ],
                    backgroundColor: [
                        'rgb(46,83,108)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgb(18,75,115)',
                    ],
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapByOs = (_byOs) => {
        if (!_byOs || _byOs.length === 0) {
            return null;
        }


        const _labels = _byOs.map(item => item.label === null ? 'NULL' : item.label === '' ? 'EMPTY' : item.os);
        const _values = _byOs.map(item => item.cant);

        let output = {}
        _labels.forEach((item, index) => {
            output = { ...output, [item]: _values[index] }
        })
        setByOSRawData([output])

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: [
                        'rgb(97,173,225)',
                        'rgba(54, 162, 235, 1)',
                        'rgb(18,137,218)',
                        'rgb(0,102,204)',
                    ],
                    backgroundColor: [
                        'rgb(46,83,108)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgb(18,75,115)',
                        'rgba(0,51,102, 0.2)',
                    ],
                    borderWidth: 1,
                }
            ],
        };
    }


    // sessionsMapping
    const mapSessionsByDom = (_byDom) => {
        if (!_byDom || _byDom.length === 0) {
            return null;
        }

        const _labels = _byDom.map(item => item.label);
        const _values = _byDom.map(item => item.cant);

        let output = {}
        _labels.forEach((item, index) => {
            output = { ...output, [item]: _values[index] }
        })
        setSessionsByDOMRawData([output])

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(13,0,132)',
                    backgroundColor: 'rgba(0,80,145,0.75)',
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapSessionsByActivityXC = (_byActivity) => {
        if (!_byActivity || _byActivity.length === 0) {
            return null;
        }

        let _activities = _byActivity.filter(item => item?.label?.startsWith('XC'));

        // Ordena _byActivity por cantidad descendente y toma solo el top 20
        _activities = _activities.sort((a, b) => b.cant - a.cant).slice(0, 30);

        const _labels = _activities.map(item => item.label);
        const _values = _activities.map(item => item.cant);

        let output = {}
        _labels.forEach((item, index) => {
            output = { ...output, [item]: _values[index] }
        })

        setSessionsByActivityXCData([output])

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(51,153,0)',
                    backgroundColor: 'rgba(51,153,0, .60)',
                    borderWidth: 1,
                }
            ],
        };
    }


    const mapSessionsByActivityXH = (_byActivity) => {
        if (!_byActivity || _byActivity.length === 0) {
            return null;
        }

        let _activities = _byActivity.filter(item => item?.label?.startsWith('XH'));

        // Ordena _byActivity por cantidad descendente y toma solo el top 20
        _activities = _activities.sort((a, b) => b.cant - a.cant).slice(0, 30);

        const _labels = _activities.map(item => item.label);
        const _values = _activities.map(item => item.cant);

        let output = {}
        _labels.forEach((item, index) => {
            output = { ...output, [item]: _values[index] }
        })

        setSessionsByActivityXHData([output])

        return {
            labels: _labels,
            datasets: [
                {
                    label: '',
                    data: _values,
                    borderColor: 'rgb(0,165,234)',
                    backgroundColor: 'rgba(0,165,234, .60)',
                    borderWidth: 1,
                }
            ],
        };
    }

    const mapSessionsByParkDay = (_byParkDay) => {
        setSessionsByParkDayRawData(_byParkDay);

        const _dates = _byParkDay.map((item) => {
            return item.date;
        });

        setSessionsByParkDayHeaders(_dates);

        const _XC = _byParkDay.map((item) => item.XC > 0 ? item.XC : 0);
        const _XH = _byParkDay.map((item) => item.XH > 0 ? item.XH : 0);
        // const _XP = _redeemedByUdn.map((item) => item.XP > 0 ? item.XP : 0);
        // const _XF = _redeemedByUdn.map((item) => item.XF > 0 ? item.XF : 0);
        // const _XS = _redeemedByUdn.map((item) => item.XS > 0 ? item.XS : 0);
        // const _XV = _redeemedByUdn.map((item) => item.XV > 0 ? item.XV : 0);
        // const _XN = _redeemedByUdn.map((item) => item.XN > 0 ? item.XN : 0);
        // const _XO = _redeemedByUdn.map((item) => item.XO > 0 ? item.XO : 0);
        // const _HX = _redeemedByUdn.map((item) => item.HX > 0 ? item.HX : 0);
        // const _HXA = _redeemedByUdn.map((item) => item.HXA > 0 ? item.HXA : 0);
        // const _LCP = _redeemedByUdn.map((item) => item.LCP > 0 ? item.LCP : 0);

        return {
            labels: _dates,
            datasets: [
                {
                    label: 'Xcaret',
                    data: _XC,
                    borderColor: 'rgb(51,153,0)',
                    backgroundColor: 'rgba(51,153,0, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xel-Ha',
                    data: _XH,
                    borderColor: 'rgb(0,165,234)',
                    backgroundColor: 'rgba(0,165,234, .60)',
                    borderWidth: 1,
                },
                // {
                //     label: 'Xplor',
                //     data: _XP,
                //     borderColor: 'rgb(255, 102, 0)',
                //     backgroundColor: 'rgba(255, 102, 0, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xplor Fuego',
                //     data: _XF,
                //     borderColor: 'rgb(255, 71 , 20)',
                //     backgroundColor: 'rgba(255, 71 , 20, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xenses',
                //     data: _XS,
                //     borderColor: 'rgb(255, 215, 0)',
                //     backgroundColor: 'rgba(255, 215, 0, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xavage',
                //     data: _XV,
                //     borderColor: 'rgb(255, 4, 0)',
                //     backgroundColor: 'rgba(255, 4, 0, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xenotes',
                //     data: _XN,
                //     borderColor: 'rgb(1, 41, 108)',
                //     backgroundColor: 'rgba(1, 41, 108, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xoximilco',
                //     data: _XO,
                //     borderColor: 'rgb(255, 0, 153)',
                //     backgroundColor: 'rgba(255, 0, 153, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Hotel Xcaret México',
                //     data: _HX,
                //     borderColor: 'rgb(165, 140, 128)',
                //     backgroundColor: 'rgba(165, 140, 128, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Hotel Xcaret Arte',
                //     data: _HXA,
                //     borderColor: 'rgb(117, 39, 162)',
                //     backgroundColor: 'rgba(117, 39, 162, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'La Casa de la Playa',
                //     data: _LCP,
                //     borderColor: 'rgb(212, 140, 121)',
                //     backgroundColor: 'rgba(212, 140, 121, .60)',
                //     borderWidth: 1,
                // },
            ],

        };
    }

    const mapDevicesByParkDay = (_byParkDay) => {
        setDevicesByParkDayRawData(_byParkDay);

        const _dates = _byParkDay.map((item) => {
            return item.date;
        });

        setDevicesByParkDayHeaders(_dates);

        const _XC = _byParkDay.map((item) => item.XC > 0 ? item.XC : 0);
        const _XH = _byParkDay.map((item) => item.XH > 0 ? item.XH : 0);
        // const _XP = _redeemedByUdn.map((item) => item.XP > 0 ? item.XP : 0);
        // const _XF = _redeemedByUdn.map((item) => item.XF > 0 ? item.XF : 0);
        // const _XS = _redeemedByUdn.map((item) => item.XS > 0 ? item.XS : 0);
        // const _XV = _redeemedByUdn.map((item) => item.XV > 0 ? item.XV : 0);
        // const _XN = _redeemedByUdn.map((item) => item.XN > 0 ? item.XN : 0);
        // const _XO = _redeemedByUdn.map((item) => item.XO > 0 ? item.XO : 0);
        // const _HX = _redeemedByUdn.map((item) => item.HX > 0 ? item.HX : 0);
        // const _HXA = _redeemedByUdn.map((item) => item.HXA > 0 ? item.HXA : 0);
        // const _LCP = _redeemedByUdn.map((item) => item.LCP > 0 ? item.LCP : 0);

        return {
            labels: _dates,
            datasets: [
                {
                    label: 'Xcaret',
                    data: _XC,
                    borderColor: 'rgb(51,153,0)',
                    backgroundColor: 'rgba(51,153,0, .60)',
                    borderWidth: 1,
                },
                {
                    label: 'Xel-Ha',
                    data: _XH,
                    borderColor: 'rgb(0,165,234)',
                    backgroundColor: 'rgba(0,165,234, .60)',
                    borderWidth: 1,
                },
                // {
                //     label: 'Xplor',
                //     data: _XP,
                //     borderColor: 'rgb(255, 102, 0)',
                //     backgroundColor: 'rgba(255, 102, 0, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xplor Fuego',
                //     data: _XF,
                //     borderColor: 'rgb(255, 71 , 20)',
                //     backgroundColor: 'rgba(255, 71 , 20, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xenses',
                //     data: _XS,
                //     borderColor: 'rgb(255, 215, 0)',
                //     backgroundColor: 'rgba(255, 215, 0, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xavage',
                //     data: _XV,
                //     borderColor: 'rgb(255, 4, 0)',
                //     backgroundColor: 'rgba(255, 4, 0, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xenotes',
                //     data: _XN,
                //     borderColor: 'rgb(1, 41, 108)',
                //     backgroundColor: 'rgba(1, 41, 108, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Xoximilco',
                //     data: _XO,
                //     borderColor: 'rgb(255, 0, 153)',
                //     backgroundColor: 'rgba(255, 0, 153, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Hotel Xcaret México',
                //     data: _HX,
                //     borderColor: 'rgb(165, 140, 128)',
                //     backgroundColor: 'rgba(165, 140, 128, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'Hotel Xcaret Arte',
                //     data: _HXA,
                //     borderColor: 'rgb(117, 39, 162)',
                //     backgroundColor: 'rgba(117, 39, 162, .60)',
                //     borderWidth: 1,
                // },
                // {
                //     label: 'La Casa de la Playa',
                //     data: _LCP,
                //     borderColor: 'rgb(212, 140, 121)',
                //     backgroundColor: 'rgba(212, 140, 121, .60)',
                //     borderWidth: 1,
                // },
            ],

        };
    }

    return (
        <div>
            {loading && showLoader()}
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>
                </CardTitle>
                <AppRequestLogDashboardFilters refreshFiltered={refreshFiltered} />
                <CardBody>
                    <div className={'form-container'}>
                        <div className={''}>
                            <h2>{'Rendimiento del sistema'}</h2>
                        </div>

                        <br />
                        <div className={''}>
                            <h3>{`Tiempos de respuesta (en milisegundos):`}</h3>
                            <Row>
                                <Col>
                                    <h2>{`Min: ${executionTimeMin}`}</h2>
                                </Col>
                                <Col>
                                    <h2>{`Max: ${executionTimeMax}`}</h2>
                                </Col>
                                <Col>
                                    <h2>{`Avg: ${executionTimeAvg}`}</h2>
                                </Col>
                            </Row>
                        </div>

                        <br />
                        <div className={''}>
                            <h3>{`Promedio de solicitudes por minuto:`}</h3>
                            <Row>
                                <Col>
                                    <h2>{avgRequestPerMinute}</h2>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    {
                        byDOM != null && <CardChartBar
                            title='Solicitudes de "Llevame"'
                            rawData={byDOMRawData}
                            graphicData={byDOM}
                        />
                    }

                    {
                        sessionsByParkDay != null && <CardChartBar
                            title='Viajes por parque '
                            rawData={sessionsByParkDayRawData}
                            headers={sessionsByParkDayHeaders}
                            graphicData={sessionsByParkDay}
                        />
                    }
                    <Row>
                        <Col className='col-md-12'>
                        </Col>
                    </Row>


                    <Row>
                        <Col className='col-md-12'>
                            {
                                devicesByParkDay != null && <CardChartBar
                                    title='Dispositivos o Paxes que solicitaron viajes'
                                    rawData={devicesByParkDayRawData}
                                    headers={devicesByParkDayHeaders}
                                    graphicData={devicesByParkDay}
                                />
                            }
                        </Col>
                    </Row>


                    <Row>
                        <Col  md={12}>
                            {
                                sessionsByActivityXC != null && <CardChartBar
                                    title='Viajes por actividad Xcaret'
                                    rawData={sessionsByActivityXCRawData}
                                    graphicData={sessionsByActivityXC}
                                />
                            }
                        </Col>
                        <Col  md={12}>
                            {
                                sessionsByActivityXH != null && <CardChartBar
                                    title='Viajes por actividad Xel-Há'
                                    rawData={sessionsByActivityXHRawData}
                                    graphicData={sessionsByActivityXH}
                                />
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
}